import { render } from "./TownMarkersVue.vue?vue&type=template&id=67bb0a7b&scoped=true"
import script from "./TownMarkersVue.vue?vue&type=script&lang=js"
export * from "./TownMarkersVue.vue?vue&type=script&lang=js"

import "./TownMarkersVue.vue?vue&type=style&index=0&id=67bb0a7b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bb0a7b"]])

export default __exports__